import React, { useEffect, useState } from "react";
import "./InputandSelect.css";

const DiscountBox = ({
  options = [], // Array of {label, value} objects
  onChange,
  onSelectChange,
  className = "",
  defaultValue = "",
  defaultOption = "", // This should be the value, not the full option object
  selectDefaultValue = "", // Allow backwards compatibility with earlier usage
  readOnly = false,
  border = "",
}) => {
  const [value, setValue] = useState(defaultValue);
  const [selectedOption, setSelectedOption] = useState(
    selectDefaultValue || defaultOption,
  );
  const [isOpen, setIsOpen] = useState(false);

  // Helper function to find option by value
  const findOptionByValue = (value) => {
    return options.find((option) => option.value === value) || options[0];
  };

  // Helper function to get label for display
  const getDisplayLabel = (value) => {
    const option = findOptionByValue(value);
    return option ? option.label : value;
  };

  const handleSelect = (option) => {
    setSelectedOption(option.value); // Store only the value
    setIsOpen(false);

    if (onSelectChange) {
      const syntheticEvent = {
        target: {
          value: option.value, // Pass only the value, not the full option
        },
      };
      onSelectChange(syntheticEvent);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setSelectedOption(selectDefaultValue || defaultOption); // defaultOption should be the value
  }, [defaultOption, selectDefaultValue]);

  const handleInputChange = (event) => {
    let newValue = event.target.value;

    // Allow only numbers with optional one decimal point
    if (/^\d*\.?\d*$/.test(newValue)) {
      setValue(newValue);

      if (onChange) {
        const modifiedEvent = {
          ...event,
          target: {
            ...event.target,
            value: newValue,
          },
        };
        onChange(modifiedEvent);
      }
    }
  };

  return (
    <div className={`input-dropdown-container ${className}`}>
      <input
        value={value}
        readOnly={readOnly}
        onChange={handleInputChange}
        className={`input-field common-text ${border}`}
      />

      <div className="select-wrapper">
        <button
          onClick={() => !readOnly && setIsOpen(!isOpen)}
          className={`select-button common-text ${border}`}
          style={{ cursor: readOnly ? "default" : "pointer" }}
        >
          {getDisplayLabel(selectedOption)} {/* Display label */}
          <span className="select-arrow" />
        </button>

        {isOpen && !readOnly && (
          <div className="dropdown-container">
            {options.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                className={`dropdown-option common-text ${
                  selectedOption === option.value ? "selected" : ""
                }`}
              >
                {option.label} {/* Display label */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscountBox;
